import {Link} from '@primer/react'
import {useMergeControlState, useMergeControlInputs} from '../merge-control-context'

export function DisableAutoMergeInstructions() {
  const {isMergeQueueEnabled} = useMergeControlState()
  const {
    pullRequest: {autoMergeRequest},
  } = useMergeControlInputs()

  const autoMergeVerb = autoMergeRequest?.mergeMethod?.toLowerCase() ?? 'merge'
  const autoMergeMessage = isMergeQueueEnabled ? 'be added to the merge queue' : `${autoMergeVerb} automatically`

  return (
    <div className="flex-1">
      This pull request will <span className="text-semibold">{autoMergeMessage}</span> when all requirements are met.{' '}
      <Link
        inline
        href="https://docs.github.com/en/pull-requests/collaborating-with-pull-requests/incorporating-changes-from-a-pull-request/automatically-merging-a-pull-request"
      >
        Learn more about automatically merging a pull request.
      </Link>
    </div>
  )
}
